export enum TestId {
    TextWaitingForOthers = 'text-waiting-for-others',
    VideoRemote = 'video-remote',
    ButtonSettingsBack = 'button-settings-back',
}
